/**
 * Admin Routes - Rotas administrativas (necessitam role admin/mensure)
 * Nota: Estas rotas são aninhadas sob /admin/* em App.js, então usam caminhos relativos
 */
import { Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/organisms/auth/ProtectedRoute';
import AdminDashboardPage from '../pages/admin/AdminDashboardPage';
import PendingDomainsPage from '../pages/admin/PendingDomainsPage';
import SystemConfigPage from '../pages/admin/SystemConfigPage';
import DomainsManagementPage from '../pages/admin/DomainsManagementPage';
import CacheManagementPage from '../pages/admin/CacheManagementPage';
import CPCManagementPage from '../pages/admin/CPCManagementPage';
import ProfileFollowersManagementPage from '../pages/admin/ProfileFollowersManagementPage';
import StoryViewRateManagementPage from '../pages/admin/StoryViewRateManagementPage';
import ScraperConfigPage from '../pages/admin/ScraperConfigPage';
import SentimentAnalysisPage from '../pages/admin/SentimentAnalysisPage';
import MIATokenManagementPage from '../pages/admin/MIATokenManagementPage';
import GlobalSourceManagementPage from '../pages/admin/GlobalSourceManagementPage';
import CategoryManagementPage from '../pages/admin/CategoryManagementPage';
import BrandManagementPage from '../pages/admin/BrandManagementPage';
import UserManagementPage from '../pages/admin/UserManagementPage';
import DiscoveryPanel from '../pages/admin/DiscoveryPanel/DiscoveryPanel';
import GlobalArticlesPage from '../pages/admin/GlobalArticlesPage';
import AdminTemplateManager from '../pages/admin/AdminTemplateManager';
import SystemDashboardPage from '../pages/admin/SystemDashboardPage';
import TierManagementPage from '../pages/admin/TierManagementPage';
import SourceRegistryPage from '../pages/admin/SourceRegistryPage';

const AdminRoutes = () => {
    return (
        <>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={
                <ProtectedRoute requireAdminOrMensure>
                    <AdminDashboardPage />
                </ProtectedRoute>
            } />
            <Route path="pending-domains" element={
                <ProtectedRoute requireAdminOrMensure>
                    <PendingDomainsPage />
                </ProtectedRoute>
            } />
            <Route path="config" element={
                <ProtectedRoute requireAdminOrMensure>
                    <SystemConfigPage />
                </ProtectedRoute>
            } />
            <Route path="domains" element={
                <ProtectedRoute requireAdminOrMensure>
                    <DomainsManagementPage />
                </ProtectedRoute>
            } />
            <Route path="cache" element={
                <ProtectedRoute requireAdminOrMensure>
                    <CacheManagementPage />
                </ProtectedRoute>
            } />
            <Route path="cpc" element={
                <ProtectedRoute requireAdminOrMensure>
                    <CPCManagementPage />
                </ProtectedRoute>
            } />
            <Route path="profile-followers" element={
                <ProtectedRoute requireAdminOrMensure>
                    <ProfileFollowersManagementPage />
                </ProtectedRoute>
            } />
            <Route path="story-view-rate" element={
                <ProtectedRoute requireAdminOrMensure>
                    <StoryViewRateManagementPage />
                </ProtectedRoute>
            } />
            <Route path="scraper-config" element={
                <ProtectedRoute requireAdminOrMensure>
                    <ScraperConfigPage />
                </ProtectedRoute>
            } />
            <Route path="sentiment-analysis" element={
                <ProtectedRoute requireAdminOrMensure>
                    <SentimentAnalysisPage />
                </ProtectedRoute>
            } />
            <Route path="mia-tokens" element={
                <ProtectedRoute requireAdminOrMensure>
                    <MIATokenManagementPage />
                </ProtectedRoute>
            } />
            <Route path="global-sources" element={
                <ProtectedRoute requireAdminOrMensure>
                    <GlobalSourceManagementPage />
                </ProtectedRoute>
            } />
            <Route path="source-registry" element={
                <ProtectedRoute requireAdminOrMensure>
                    <SourceRegistryPage />
                </ProtectedRoute>
            } />
            <Route path="categories" element={
                <ProtectedRoute requireAdminOrMensure>
                    <CategoryManagementPage />
                </ProtectedRoute>
            } />
            <Route path="brands" element={
                <ProtectedRoute requireAdminOrMensure>
                    <BrandManagementPage />
                </ProtectedRoute>
            } />
            <Route path="users" element={
                <ProtectedRoute requireAdminOrMensure>
                    <UserManagementPage />
                </ProtectedRoute>
            } />
            <Route path="discovery" element={
                <ProtectedRoute requireAdminOrMensure>
                    <DiscoveryPanel />
                </ProtectedRoute>
            } />
            <Route path="global-articles" element={
                <ProtectedRoute requireAdminOrMensure>
                    <GlobalArticlesPage />
                </ProtectedRoute>
            } />
            <Route path="templates" element={
                <ProtectedRoute requireAdminOrMensure>
                    <AdminTemplateManager />
                </ProtectedRoute>
            } />
            <Route path="system" element={
                <ProtectedRoute requireAdminOrMensure>
                    <SystemDashboardPage />
                </ProtectedRoute>
            } />
            <Route path="tiers" element={
                <ProtectedRoute requireAdminOrMensure>
                    <TierManagementPage />
                </ProtectedRoute>
            } />
        </>
    );
};

export default AdminRoutes;
